<script>
    import vSelect from 'vue-select';

    export default {
        components: {
            vSelect,
        },
        props: {
            name: null,
            elementName: null,
            value: null,
            selectValue: null,
            selectLabel: null,
            placeholder: ''
        },
        data() {
            return {
                selectData: [],
                selectedObject: null,
                nameMutable: this.name,
                elementNameMutable: this.elementName,
                valueMutable: this.value || 0,
                params: null,
                hasError: false,
                selected: null,
            }
        },
        created() {
            this.registerToStore();
            window.formElementRelations.$on('inputAdded', this.fetchDataIfNecessary);
        },
        watch: {
            value(value) {
                this.valueMutable = value;
            },
            selectedObject(selected) {
                this.checkForError(selected);

                this.valueMutable = selected ? selected.value : 0;
                this.registerToStore();

                this.$emit('update:value', {
                    name: this.name,
                    selectedObject: selected ?  this.selectedObject : 0
                });
            }
        },
        methods: {
            registerToStore() {
                window.formElementRelations.addInteractiveInput(this.elementNameMutable, this.valueMutable);
            },
            fetchDataIfNecessary(params) {
                if (this.params !== this.removeYourselfFromParams(params)) {
                    $(this.$el).addClass('loading');
                    this.params = this.removeYourselfFromParams(params);

                    axios.get(Scoop.baseUrl + '/api/interactiveInput/' + this.elementNameMutable, {
                        params: {'values': this.params, selected: this.value}
                    }).then((response) => {
                        this.selectData = _.map(response.data, (option) => {
                            return {'value': option[this.selectValue], 'label': option[this.selectLabel]};
                        });

                        if (this.valueMutable) {
                            this.setSelectedObject();
                        }

                        $(this.$el).removeClass('loading');
                    });
                }
            },
            removeYourselfFromParams(params) {
                return JSON.stringify(_.pickBy(params, (val, key) => {
                    return key != this.elementNameMutable;
                }));
            },
            checkForError(selected) {
                /* If selected is not set, there cannot be an error. If it's an object, as expected, also everything is fine. */

                if (!selected || typeof selected === 'object') {
                    this.hasError = false;
                } else {
                    this.hasError = true;
                }
            },
            setSelectedObject() {
                this.selectedObject = _.first(_.filter(this.selectData, (option) => {
                    return parseInt(option.value) === parseInt(this.valueMutable);
                }));

                if (!this.selectedObject) {
                    this.selectedObject = this.valueMutable;
                }

                this.$emit('update:value', {
                    name: this.name,
                    selectedObject: this.selectedObject ? this.selectedObject.value : null
                });
            }
        },
    }
</script>

<template>
    <div>
        <v-select
            :name="name"
            :options="selectData"
            :style="hasError ? 'box-shadow: #ed5565 0 0 0 2px;' : ''"
            v-model="selectedObject"
            :placeholder="this.placeholder"
        ></v-select>
        <span class="errorMsg" v-if="hasError"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Your selected relation is incorrect!</span>
        <input type="hidden" :name="nameMutable" :value="valueMutable">
    </div>
</template>
